import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react";

const LABEL = msg({ id: "analysis.fix.label", message: "How to fix:" });

// Общий совет «как исправить» одной строкой.
export const FixTip = ({ tip }: { tip: MessageDescriptor }) => {
  const { _ } = useLingui();
  return (
    <p className="text-sm text-foreground-soft">
      <span className="font-semibold text-accent">{_(LABEL)}</span> {_(tip)}
    </p>
  );
};
